import { api } from '../api.js';
import { resetStore, store } from '../store.js';
import { navigate } from '../router.js';

export function renderHeader({ active = '' } = {}) {
  const email = store.user?.email ?? '';
  const level = store.user?.currentLevel ?? '';
  const form = store.form;
  const formBadge = form
    ? `<span class="header-form" title="Форма · тир ${form.tier}">⚡ ${Math.round(form.score)}</span>`
    : '';
  const isAdmin = store.user?.role === 'admin';
  return `
    <header class="header">
      <div class="brand">Chunkly.ru</div>
      <div class="header-right">
        ${formBadge}
        <button type="button" class="burger" id="burger-toggle" aria-label="Меню" aria-expanded="false">
          <span></span><span></span><span></span>
        </button>
      </div>
      <nav class="burger-menu" id="burger-menu" data-active="${active}">
        <div class="burger-menu-head">
          <div class="burger-menu-user">
            <div class="burger-menu-email">${email || '—'}</div>
            <div class="burger-menu-sub text-muted">${level ? `Уровень ${level}` : ''}${form ? ` · Форма ${Math.round(form.score)}` : ''}</div>
          </div>
          <button type="button" class="burger-close" id="burger-close" aria-label="Закрыть меню">✕</button>
        </div>
        <ul class="burger-links">
          <li><a href="/" data-link class="${active === 'home' ? 'active' : ''}">Главная</a></li>
          <li><a href="/trainer" data-link class="${active === 'trainer' ? 'active' : ''}">Тренажёр</a></li>
          <li><a href="/support" data-link class="${active === 'support' ? 'active' : ''}">Поддержка</a></li>
          ${isAdmin ? `
            <li class="burger-section">Админ</li>
            <li><a href="/admin/tickets" data-link class="${active === 'admin-tickets' ? 'active' : ''}">Тикеты</a></li>
            <li><a href="/admin/users" data-link class="${active === 'admin' ? 'active' : ''}">Пользователи</a></li>
            <li><a href="/admin/settings" data-link class="${active === 'admin-settings' ? 'active' : ''}">Настройки</a></li>
          ` : ''}
          <li><a href="#" id="logout-link">Выйти</a></li>
        </ul>
      </nav>
      <div class="burger-backdrop" id="burger-backdrop"></div>
    </header>
  `;
}

export function bindHeader() {
  const logoutLink = document.getElementById('logout-link');
  const burger = document.getElementById('burger-toggle');
  const close = document.getElementById('burger-close');
  const backdrop = document.getElementById('burger-backdrop');

  const open = () => {
    document.body.classList.add('burger-open');
    burger?.setAttribute('aria-expanded', 'true');
  };
  const shut = () => {
    document.body.classList.remove('burger-open');
    burger?.setAttribute('aria-expanded', 'false');
  };

  burger?.addEventListener('click', (e) => {
    e.stopPropagation();
    if (document.body.classList.contains('burger-open')) shut();
    else open();
  });
  close?.addEventListener('click', shut);
  backdrop?.addEventListener('click', shut);

  document.getElementById('burger-menu')?.querySelectorAll('a[data-link]').forEach((a) => {
    a.addEventListener('click', shut);
  });

  if (logoutLink) {
    logoutLink.addEventListener('click', async (e) => {
      e.preventDefault();
      shut();
      try { await api.auth.logout(); } catch {}
      resetStore();
      navigate('/login');
    });
  }
}
